define.alias("shared/components/shared/pre-boarding/survey-components/text-input", "media/components/shared/pre-boarding/survey-components/text-input");